// src\data\products.tsx
import { Product } from "@/types/product";
import laptop from "@/data/products/laptop";
import komputer from "@/data/products/komputer";
import server from "@/data/products/server";
import printer from "@/data/products/printer";
import kamera from "@/data/products/kamera";
import tv from "@/data/products/tv";
import videotron from "@/data/products/videotron";
import proyektor from "@/data/products/proyektor";
import soundSystem from "@/data/products/sound-system";
import genset from "@/data/products/genset";
import tablet from "@/data/products/tablet";
import cctv from "@/data/products/cctv";
import lighting from "@/data/products/lighting";
import custom from "@/data/products/custom";

const products: Product[] = [
  ...laptop,
  ...komputer,
  ...server,
  ...printer,
  ...kamera,
  ...tv,
  ...videotron,
  ...proyektor,
  ...soundSystem,
  ...genset,
  ...tablet,
  ...cctv,
  ...lighting,
  ...custom,
];

export default products;